import { Action } from '@ngrx/store';
import { EmployeeDiscomfortLevelDetailsInterface } from 'app/reports/management-overview/models/chart-details/employee-discomfort-level-details.model';
import { EmployeeRiskLevelDetailsInterface } from 'app/reports/management-overview/models/chart-details/employee-risk-level-details.model';
import { GenericChartInterface } from 'app/reports/models';

import { ManagementOverviewActionType } from './management-overview-action-type.enum';

export class LoadEmployeeDiscomfortLevel implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeDiscomfortLevel;
  public readonly payload: any = undefined;
}

export class LoadEmployeeDiscomfortLevelCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeDiscomfortLevelCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadEmployeeDiscomfortLevelFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeDiscomfortLevelFailed;

  constructor(public readonly payload: string) { }
}

export class LoadEmployeeDiscomfortLevelDetails implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeDiscomfortLevelDetails;

  constructor(public readonly payload: number[]) { }
}

export class LoadEmployeeDiscomfortLevelDetailsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeDiscomfortLevelDetailsCompleted;

  constructor(public readonly payload: EmployeeDiscomfortLevelDetailsInterface[]) { }
}

export class LoadEmployeeDiscomfortLevelDetailsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeDiscomfortLevelDetailsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadEmployeeRiskLevel implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeRiskLevel;
  public readonly payload: any = undefined;
}

export class LoadEmployeeRiskLevelCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeRiskLevelCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadEmployeeRiskLevelFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeRiskLevelFailed;

  constructor(public readonly payload: string) { }
}

export class LoadEmployeeRiskLevelDetails implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeRiskLevelDetails;

  constructor(public readonly payload: number[]) { }
}

export class LoadEmployeeRiskLevelDetailsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeRiskLevelDetailsCompleted;

  constructor(public readonly payload: EmployeeRiskLevelDetailsInterface[]) { }
}

export class LoadEmployeeRiskLevelDetailsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadEmployeeRiskLevelDetailsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadTopTenDiscomfort implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadTopTenDiscomfort;
  public readonly payload: any = undefined;
}

export class LoadTopTenDiscomfortCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadTopTenDiscomfortCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadTopTenDiscomfortFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadTopTenDiscomfortFailed;

  constructor(public readonly payload: string) { }
}

export class LoadTopTenDiscomfortDetails implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadTopTenDiscomfortDetails;

  constructor(public readonly payload: number[]) { }
}

export class LoadTopTenDiscomfortDetailsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadTopTenDiscomfortDetailsCompleted;

  constructor(public readonly payload: EmployeeDiscomfortLevelDetailsInterface[]) { }
}

export class LoadTopTenDiscomfortDetailsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadTopTenDiscomfortDetailsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadDiscomfortLevelTrend implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadDiscomfortLevelTrend;
  public readonly payload: any = undefined;
}

export class LoadDiscomfortLevelTrendCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadDiscomfortLevelTrendCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadDiscomfortLevelTrendFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadDiscomfortLevelTrendFailed;

  constructor(public readonly payload: string) { }
}

export class LoadDiscomfortLevelTrendDetails implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadDiscomfortLevelTrendDetails;

  constructor(public readonly payload: number[]) { }
}

export class LoadDiscomfortLevelTrendDetailsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadDiscomfortLevelTrendDetailsCompleted;

  constructor(public readonly payload: EmployeeDiscomfortLevelDetailsInterface[]) { }
}

export class LoadDiscomfortLevelTrendDetailsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadDiscomfortLevelTrendDetailsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadRiskLevelTrend implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadRiskLevelTrend;
  public readonly payload: any = undefined;
}

export class LoadRiskLevelTrendCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadRiskLevelTrendCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadRiskLevelTrendFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadRiskLevelTrendFailed;

  constructor(public readonly payload: string) { }
}

export class LoadRiskLevelTrendDetails implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadRiskLevelTrendDetails;

  constructor(public readonly payload: number[]) { }
}

export class LoadRiskLevelTrendDetailsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadRiskLevelTrendDetailsCompleted;

  constructor(public readonly payload: EmployeeRiskLevelDetailsInterface[]) { }
}

export class LoadRiskLevelTrendDetailsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadRiskLevelTrendDetailsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadPosturalRisk implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadPosturalRisk;
  public readonly payload: any = undefined;
}

export class LoadPosturalRiskCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadPosturalRiskCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadPosturalRiskFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadPosturalRiskFailed;

  constructor(public readonly payload: string) { }
}

export class LoadPosturalRiskDetails implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadPosturalRiskDetails;

  constructor(public readonly payload: number[]) { }
}

export class LoadPosturalRiskDetailsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadPosturalRiskDetailsCompleted;

  constructor(public readonly payload: EmployeeRiskLevelDetailsInterface[]) { }
}

export class LoadPosturalRiskDetailsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadPosturalRiskDetailsFailed;

  constructor(public readonly payload: string) { }
}

export class LoadProgramBenefits implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadProgramBenefits;
  public readonly payload: any = undefined;
}

export class LoadProgramBenefitsCompleted implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadProgramBenefitsCompleted;

  constructor(public readonly payload: GenericChartInterface) { }
}

export class LoadProgramBenefitsFailed implements Action {
  public readonly type: ManagementOverviewActionType = ManagementOverviewActionType.LoadProgramBenefitsFailed;

  constructor(public readonly payload: string) { }
}
